import { Component, Injector } from "@angular/core";
import { ArrayUtilities } from "@common/lib/utilities/array-utilities";
import { IConfigItem } from "@org-common/lib/configuration/configuration.interfaces";
import { WorkflowStepComponent } from "@org-common/lib/workflow/workflow-component-registry";
import { SelectionChangedEvent } from "devextreme/ui/list";
import isEqual from "lodash.isequal";
import { AddTeamWorkflowStepBaseComponent } from "../add-team-workflow-step-base.component";

@WorkflowStepComponent("adapt-add-team-features-step")
@Component({
    selector: "adapt-add-team-features-step",
    templateUrl: "./add-team-features-step.component.html",
    styleUrl: "./add-team-features-step.component.css",
    standalone: false,
})
export class AddTeamFeaturesStepComponent extends AddTeamWorkflowStepBaseComponent {
    public featureConfigItems: IConfigItem[] = [];

    public constructor(
        injector: Injector,
    ) {
        super(injector);
    }

    public async workflowStepOnInit() {
        super.workflowStepOnInit();

        // only features active in the organisation will be displayed
        this.featureConfigItems = this.getActiveTeamConfigItems();

        this.updateCustomisedFeaturesState();
    }

    public onSelectionChanged(e: SelectionChangedEvent<IConfigItem>) {
        const { teamFeatures } = this.runData.createTeamBindingModel;

        for (const addedFeature of e.addedItems) {
            ArrayUtilities.addElementIfNotAlreadyExists(teamFeatures, addedFeature.featureName!);
        }

        for (const removedFeature of e.removedItems) {
            ArrayUtilities.removeElementFromArray(removedFeature.featureName!, teamFeatures);
        }

        this.updateCustomisedFeaturesState();
    }

    public resetToDefault() {
        this.setTeamDefaultFeatures();
        this.updateCustomisedFeaturesState();
    }

    private updateCustomisedFeaturesState() {
        const selectedFeatures = Array.from(this.runData.createTeamBindingModel.teamFeatures)
            .sort((a, b) => a.localeCompare(b));
        const teamDefaultFeatures = this.getTeamDefaultFeatures()
            .sort((a, b) => a.localeCompare(b));

        this.runData.hasCustomisedFeatures = !isEqual(selectedFeatures, teamDefaultFeatures);
    }
}
